/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AttachKeySetForm,
  AttachKeySetForm$Outbound,
  AttachKeySetForm$outboundSchema,
} from "../components/attachkeysetform.js";

export type AttachOrganizationRemoteSessionClientKeySetSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type AttachOrganizationRemoteSessionClientKeySetRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  attachKeySetForm: AttachKeySetForm;
};

/** @internal */
export type AttachOrganizationRemoteSessionClientKeySetSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const AttachOrganizationRemoteSessionClientKeySetSecurity$outboundSchema:
  z.ZodMiniType<
    AttachOrganizationRemoteSessionClientKeySetSecurity$Outbound,
    AttachOrganizationRemoteSessionClientKeySetSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function attachOrganizationRemoteSessionClientKeySetSecurityToJSON(
  attachOrganizationRemoteSessionClientKeySetSecurity:
    AttachOrganizationRemoteSessionClientKeySetSecurity,
): string {
  return JSON.stringify(
    AttachOrganizationRemoteSessionClientKeySetSecurity$outboundSchema.parse(
      attachOrganizationRemoteSessionClientKeySetSecurity,
    ),
  );
}

/** @internal */
export type AttachOrganizationRemoteSessionClientKeySetRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  AttachKeySetForm: AttachKeySetForm$Outbound;
};

/** @internal */
export const AttachOrganizationRemoteSessionClientKeySetRequest$outboundSchema:
  z.ZodMiniType<
    AttachOrganizationRemoteSessionClientKeySetRequest$Outbound,
    AttachOrganizationRemoteSessionClientKeySetRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      attachKeySetForm: AttachKeySetForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        attachKeySetForm: "AttachKeySetForm",
      });
    }),
  );

export function attachOrganizationRemoteSessionClientKeySetRequestToJSON(
  attachOrganizationRemoteSessionClientKeySetRequest:
    AttachOrganizationRemoteSessionClientKeySetRequest,
): string {
  return JSON.stringify(
    AttachOrganizationRemoteSessionClientKeySetRequest$outboundSchema.parse(
      attachOrganizationRemoteSessionClientKeySetRequest,
    ),
  );
}
